<template>
  <div class="no-auth-wrapper">
    <loading
      :show="isLoading"
      :text="''"
    />
    <z-navbar />
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import ZNavbar from '@/components/noauth/ZNavbar.vue';
import Loading from '../components/shared/Loading.vue';

export default {
  name: 'NoAuthLayout',
  components: { ZNavbar, Loading },

  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    },
  },
};
</script>

<style lang="scss" scoped>
  .no-auth-wrapper {
    background: var(--color-blue-200);
    min-height: 100vh;
  }
</style>
